export const ACCEPT_AUDIO = '.aac,audio/aac,.mp3,audio/mpeg';
export const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024;
export const MAX_DURATION_SEC = 30;
export const MAX_FILES_PER_FLEET = 5;

const AAC_EXTENSION = '.aac';

export function isAacFile(file: File): boolean {
  const name = file.name.toLowerCase();
  return name.endsWith(AAC_EXTENSION) || file.type === 'audio/aac';
}

export function isWithinSizeLimit(file: File): boolean {
  return file.size <= MAX_FILE_SIZE_BYTES;
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  return `${kb.toFixed(1)} KB`;
}

export function formatDuration(seconds: number): string {
  return `${seconds.toFixed(1)} sec`;
}

export function getAudioDuration(file: File): Promise<number> {
  return new Promise((resolve, reject) => {
    const audio = document.createElement('audio');
    const objectUrl = URL.createObjectURL(file);

    audio.preload = 'metadata';
    audio.src = objectUrl;

    audio.onloadedmetadata = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(audio.duration);
    };

    audio.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Failed to read audio duration'));
    };
  });
}
